export default __webpack_public_path__ + "static/media/3img.9ce27163.png";